import React, { useState, useCallback } from 'react';
import {
  cookieToken,
  isPlayGroundMode,
  parseJwt,
} from '../../../../utils/CookieToken';
import OtpInput from 'react-otp-input';
import { Button } from '@grofers/react';
import Spinner from 'sushiweb/Spinner/Spinner';
import grey from 'sushiweb/tokens/color/grey';
import { EmptyState } from '../../../commons';
import { InvalidSearchImg } from '../../../../images/images';
import { useMutationCall, useQueryCall } from '../../../../api/react-client';
import { lifelineEndPoints } from '../../../../api/end-points';

const TotpModal = ({ qrImage = null, setShowPopUp }) => {
  const [totp, setTotp] = useState(null);
  const validateAuthQRTotpFlow = lifelineEndPoints.POST_VALIDATE_TOTP_QR;
  const [isValidOtp, setIsValidOtp] = useState(false);

  const { mutate: validateQR, isLoading: isSubmitting } = useMutationCall(
    {
      onSuccess: () => {
        setShowPopUp(false);
        setTotp(null);
      },
      onSettled: () => {
        setTotp(null);
      },
    },
    validateAuthQRTotpFlow,
    ['submit_totp'],
  );

  const handleOtpInput = useCallback(
    (val) => {
      setTotp(val);
      validateOtp(val);
    },
    [setTotp],
  );

  const validateOtp = useCallback(
    (Totp) => {
      if (Totp?.length === 6) setIsValidOtp(true);
    },
    [setIsValidOtp],
  );

  const handleTotpSubmit = useCallback(() => {
    let parsedData = parseJwt(cookieToken);
    const userName = parsedData.name;
    const userEmail = parsedData.email_id;
    validateQR({ otp: totp, email: userEmail });
  }, [totp]);

  if (!qrImage)
    return (
      <div>
        <EmptyState
          img={InvalidSearchImg}
          heading={
            'Some error occured. Please retry later or reach out to your POC.'
          }
        />
      </div>
    );

  return (
    <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-m-auto tw-w-full tw-gap-7'>
      <div className='tw-flex-col tw-gap-1 tw-items-center tw-justify-center tw-w-full'>
        <div className='tw-m-auto  tw-w-96 tw-h-96 tw-flex tw-gap-1 tw-items-center tw-justify-center'>
          <img src={qrImage} width='100%' height='100%' alt='' />
        </div>

        <div className=' tw-text-500 tw-font-medium tw-flex tw-justify-center'>
          Scan QR to enter the code from Authenticator app
        </div>
      </div>
      <div className='tw-flex tw-items-center tw-justify-center tw-w-full '>
        <OtpInput
          value={totp}
          onChange={handleOtpInput}
          numInputs={6}
          renderSeparator={<span className='tw-w-4 '></span>}
          renderInput={(props) => <input {...props} type='number' />}
          inputStyle={{
            width: '4rem',
            height: '4rem',
            borderRadius: '5px',
            outline: 'none',
            border: '2px solid #333',
          }}
          containerStyle='tw-flex tw-items-center tw-justify-center tw-text-center'
        />
      </div>
      <div className='tw-flex-col  tw-w-full tw-items-center tw-justify-center'>
        <Button
          onClick={handleTotpSubmit}
          size='medium'
          variant='fill'
          disabled={!isValidOtp}
          className={`tw-h-16 tw-w-full  ${
            isValidOtp
              ? 'tw-bg-base-black hover:tw-bg-black active:tw-bg-base-black'
              : 'tw-bg-grey-300'
          }`}
        >
          {isSubmitting ? (
            <Spinner size='small' color={`${grey.z300}`} />
          ) : (
            <span className='tw-text-400'>Submit</span>
          )}
        </Button>
      </div>
    </div>
  );
};

const GenerateQr = ({ closePopUp, setShowPopUp, setPopDetails }) => {
  const { data: totpQr, refetch: reftechTotp } = useQueryCall(
    { enabled: false },
    null,
    ['generate_qr_code'],
    async () => {
      const response = await fetch(
        `${window.location.origin}/api/crm_proxy/${
          isPlayGroundMode ? `playground` : `lifeline_apis`
        }/auth/generate_qr_code`,
      );
      if (response.status === 401) {
        return handleSignout();
      }
      const blob = await response.blob();
      if (response.ok) {
        setShowPopUp(true);
        const totpDetails = {
          type: 'medium',
          title: 'Auth App QR',
          handlClose: closePopUp,
          maxHeight: '60vh',
          component: (
            <TotpModal
              qrImage={URL.createObjectURL(blob)}
              setShowPopUp={setShowPopUp}
            />
          ),
        };
        setPopDetails(totpDetails);
        return URL.createObjectURL(blob);
      }
      if (!response.ok) {
        throw new Error(
          'Some error occurred, please try again later or reach to your POC',
        );
      }
      return Promise.reject(response);
    },
  );
  const handleTotpSignUp = useCallback(() => {
    reftechTotp();
  }, [reftechTotp]);

  return (
    <div
      className='tw-py-1 tw-w-full tw-border-solid tw-border-grey-200 tw-border-[1px] tw-border-x-0 tw-border-t-0 tw-pb-3 tw-font-medium tw-text-grey-700 tw-cursor-pointer'
      onClick={handleTotpSignUp}
    >
      Generate QR
    </div>
  );
};

export { GenerateQr };
